/**
 * @author      luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright   Copyright (c) 2022, Zumper
 * @description get href for STR external provider with dates
 */

import type { Filters } from '@zcode/state-type'
import { formatDateForFilter } from '../../../../../../modules/filters/helpers/index'

const EXTERNAL_URL_DATE_FORMAT = 'yyyy-MM-dd'

export const getProviderHref = ({
  externalUrl,
  filters,
}: {
  externalUrl?: string
  filters: Filters
}) => {
  const { startDate, endDate, guests } = filters
  const formattedStartDate = formatDateForFilter(startDate, EXTERNAL_URL_DATE_FORMAT) as string
  const formattedEndDate = formatDateForFilter(endDate, EXTERNAL_URL_DATE_FORMAT) as string
  const hasDates = formattedEndDate && formattedStartDate

  if (!externalUrl) {
    return ''
  }

  let providerHref = String(externalUrl)
  const guestsParam = guests?.length ? String(guests?.join(',')) : null
  if (formattedEndDate && formattedStartDate) {
    providerHref = `${providerHref}?start-date=${formattedStartDate}&end-date=${formattedEndDate}`
  }
  if (guestsParam) {
    providerHref = `${providerHref}${hasDates ? '&' : '?'}guests=${guestsParam}`
  }
  return providerHref
}
